export { default } from "./ScrollToTop";
